"use client";

/**
 * Sé distribuidor (simplificado): formulario directo con RUC, cédula y
 * WhatsApp de contacto. El equipo revisa y responde por WhatsApp con el
 * código de distribuidor.
 */

import { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { BottomNav, HeaderTitulo } from "@/components/app/chrome";
import { useApp } from "@/components/app/proveedor";

export default function PaginaDistribuidores() {
  const router = useRouter();
  const { usuario } = useApp();
  const [ruc, setRuc] = useState("");
  const [cedula, setCedula] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);

  async function enviar() {
    if (cargando) return;
    setError(null);
    setCargando(true);
    try {
      const res = await fetch("/api/distribuidores/solicitudes", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ruc,
          cedula,
          whatsapp: whatsapp || usuario?.telefono || "",
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        setError(data.error ?? "No pudimos enviar tu solicitud. Intenta de nuevo.");
        return;
      }
      try {
        sessionStorage.setItem("fz_sol", data.codigo);
      } catch {}
      router.push("/distribuidores/solicitud");
    } catch {
      setError("Sin conexión. Intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  }

  const inputCls =
    "h-[58px] w-full rounded-[20px] border border-black/10 bg-white px-[18px] text-base outline-0 placeholder:text-tinta/40";

  return (
    <>
      <HeaderTitulo titulo="Sé distribuidor" />
      <main className="anim-bz-in min-h-(--alto-app) px-6 pt-[100px] pb-[62px]">
        <div className="pt-[22px] pb-[30px]">
          <div className="rounded-[28px] bg-[linear-gradient(160deg,#1E8A40,#082411)] p-[26px] text-white">
            <span className="rounded-[20px] bg-lima px-3 py-[5px] text-[11px] font-bold text-bosque">
              CONVOCATORIA ABIERTA
            </span>
            <h1 className="mt-4 font-app text-[27px] leading-[31px] font-black">
              Vende boots en tu negocio
            </h1>
            <p className="mt-2.5 text-sm leading-[21px] text-white/80">
              Tiendas, gyms, cafeterías y consultorios. Déjanos tus datos y te
              escribimos por WhatsApp con tu código de distribuidor y los
              precios mayoristas.
            </p>
          </div>

          <div className="mt-5 flex flex-col gap-3.5">
            <label className="block">
              <span className="mb-1.5 block text-xs text-tinta/55">RUC</span>
              <input
                value={ruc}
                onChange={(e) => setRuc(e.target.value)}
                placeholder="1790000000001"
                inputMode="numeric"
                className={inputCls}
              />
            </label>
            <label className="block">
              <span className="mb-1.5 block text-xs text-tinta/55">
                Cédula del representante
              </span>
              <input
                value={cedula}
                onChange={(e) => setCedula(e.target.value)}
                placeholder="1700000000"
                inputMode="numeric"
                className={inputCls}
              />
            </label>
            <label className="block">
              <span className="mb-1.5 block text-xs text-tinta/55">
                WhatsApp de contacto
              </span>
              <input
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
                placeholder={
                  usuario?.telefono ? `+593 ${usuario.telefono}` : "099 123 4567"
                }
                inputMode="tel"
                className={inputCls}
              />
              {usuario?.telefono && !whatsapp && (
                <span className="mt-1.5 block text-xs text-tinta/45">
                  Si lo dejas vacío usamos el de tu cuenta.
                </span>
              )}
            </label>
          </div>

          {error && <p className="mt-3 text-sm text-[#B4463A]">{error}</p>}

          <button
            type="button"
            onClick={() => void enviar()}
            disabled={cargando}
            className="mt-5 flex h-16 w-full items-center justify-center rounded-[30px] bg-verde font-app text-[17px] font-semibold text-white transition active:scale-[.98] disabled:opacity-60"
          >
            {cargando ? "Enviando…" : "Enviar solicitud"}
          </button>

          <p className="mt-3.5 text-center text-xs leading-[18px] text-tinta/50">
            Te respondemos por WhatsApp en 24 a 48 horas laborables.
          </p>

          <Link
            href="/distribuidores/codigo"
            className="mt-4 block text-center text-[13px] text-tinta/60 underline"
          >
            Ya soy distribuidor, tengo mi código
          </Link>
        </div>
      </main>
      <BottomNav />
    </>
  );
}
